<div class="betslip-digital-single-bet-pick-stake-list">
    <bs-digital-pick-list>
        @if (shouldShowHeader()) {
            <bs-digital-combo-bet-header
                [oddsDisplayFormat]="oddsDisplayFormat"
                [comboBetState]="comboBetState()"
                [pickList]="pickList()"></bs-digital-combo-bet-header>
        }
        <bs-digital-combo-bet-pick
            *rxFor="let pick of pickList(); trackBy: pickTrackBy; renderCallback: onListRendered$"
            [pick]="pick"
            [comboBetPickState]="comboBetState().picks[pick.id.toString()]"
            [comboBetState]="comboBetState()"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [removeButtonPosition]="removeButtonPosition"
            [removeButtonStyle]="removeButtonStyle"
            [msAutomation]="pick.id.toString()">
        </bs-digital-combo-bet-pick>
    </bs-digital-pick-list>
</div>
@if (isListRendered()) {
    <bs-digital-picks-toolbar [picks]="comboBetState().picks"></bs-digital-picks-toolbar>
}
